import React from "react";
import { SpeakerphoneIcon } from "@heroicons/react/outline";
import { Link } from "gatsby";

const HeaderBanner1 = () => {
  return (
    <div className='bg-bristol-blue-2'>
      <div className='max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8'>
        <div className='flex items-center justify-between flex-wrap'>
          <div className='w-0 flex-1 flex items-center'>
            <span className='hidden md:inline p-2 rounded-lg bg-white'>
              <SpeakerphoneIcon className='h-6 w-6' aria-hidden='true' />
            </span>
            <p className='ml-3 font-medium text-white truncate'>
              <span className='md:hidden'>
                Now Hiring - Make Bristol Place your next adventure!
              </span>
              <span className='hidden md:inline'>
                Now Hiring - Make Bristol Place your next adventure!
              </span>
            </p>
          </div>
          <div className='animate-pulse order-3 mt-2 flex-shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto'>
            <Link
              to='/apply/'
              className='flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-indigo-600 bg-white hover:bg-indigo-50'
            >
              Apply Now
            </Link>
          </div>

        </div>
      </div>
    </div>
  );
};

export default HeaderBanner1;
